import { parse, type IParseOptions } from 'qs';
import { serializeQuery, type QueryObject } from './serializeQuery';
import { useTravelataAppConfig } from '../composables/useTravelataAppConfig';

const QS_PARSE_OPTIONS: IParseOptions = { depth: 5, parameterLimit: 200 };

const HASH_QUERY_PREFIX = /^#!?\??/;

export function getCurrentUrl(): string {
  if (window?.location?.href) {
    return window.location.href;
  }
  return useTravelataAppConfig().href ?? '';
}

export function getUrlQuery<T extends QueryObject = QueryObject>(url: string): T {
  const hashIndex = url.indexOf('#');
  const queryString = hashIndex === -1 ? '' : url.slice(hashIndex).replace(HASH_QUERY_PREFIX, '');

  return parse(queryString, QS_PARSE_OPTIONS) as T;
}

export function setUrlQuery(url: string, query: QueryObject): string {
  const hashIndex = url.indexOf('#');
  const base = hashIndex === -1 ? url : url.slice(0, hashIndex);
  const serialized = serializeQuery(query);

  return serialized ? `${base}#?${serialized}` : base;
}

export function omitQueryKeys<T extends QueryObject = QueryObject>(query: T, keys: readonly string[]): Partial<T> {
  const owned = new Set(keys);

  return Object.fromEntries(Object.entries(query).filter(([key]) => !owned.has(key))) as Partial<T>;
}
